module.exports = __webpack_public_path__ + "img/search_icon.25ff101d.svg";